module.exports = __webpack_public_path__ + "img/pethouse55.e892b19e.jpg";